<template>
  <v-layout :column="column" class="app-text-area-container">
    <v-flex class="label-flex" :class="labelClass">
      <v-card-text class="app-input-label">
        <v-layout>
          <v-flex grow>
            {{ labelLocalize ? $t(label): label }}
            <span v-show="required && !!label">*</span>
          </v-flex>
          <v-flex shrink>
            <slot name="label-append"></slot>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-flex>
    <v-flex class="input-flex" :class="inputClass" v-bind="inputFlexAttrs">
      <v-textarea :value="value" class="app-text-area" :rules="validationRules" :clearable="isClearable" @input="input" validate-on-blur
        v-bind="attrs" :disabled="disabled" @keydown="$emit('keydown', $event)" @change="$emit('change', $event)">
        <template v-slot:append>
          <slot name="append"></slot>
        </template>
      </v-textarea>
    </v-flex>
  </v-layout>
</template>

<script>
import { getLocale } from '@/helpers/locale-helper';
import merge from 'lodash/merge';

export default {
  name: 'AppTextArea',
  inheritAttrs: false,
  data: function() {
    return {
      attrs: { 'auto-grow': true, 'no-resize': false, rows: 3, 'validate-on-blur': true },
      column: true,
      inputFlexAttrs: {},
      maxLength: 0,
      row: false,
      validationRules: [],
      rulesPreset: {
        maxLength: v => !this.maxLength || !v || v.length <= this.maxLength || getLocale('validate.maxLength', { len: this.maxLength }),
        required: v => !this.required || !!v || getLocale('validate.exist')
      }
    };
  },
  props: {
    inputClass: { default: '' },
    label: { default: '' },
    labelClass: { default: '' },
    rules: undefined,
    value: { default: '' },
    labelLocalize: { default: true }
  },
  created() {
    this.attrs = merge(this.attrs, this.$attrs);
    if ('row' in this.$attrs) {
      this.column = false;
      this.row = true;
    }
    let sizes = Object.keys(this.$attrs).filter(a => /^xs|sm|md|lg|xl/.test(a));
    sizes.forEach(s => (this.inputFlexAttrs[s] = ''));

    this.validationRules.push(this.rulesPreset.required);

    if ('counter' in this.$attrs) {
      this.maxLength = Number(this.$attrs.counter);
    }
    if (this.maxLength && !isNaN(this.maxLength)) {
      this.validationRules.push(this.rulesPreset.maxLength);
    }
    this.validationRules = this.validationRules.concat(this.$props.rules || []);
  },
  computed: {
    required() {
      return 'required' in this.$attrs && this.$attrs.required !== false;
    },
    readonly() {
      return 'readonly' in this.$attrs && this.$attrs.readonly !== false;
    },
    isClearable() {
      return !this.readonly && (!('clearable' in this.$attrs) || this.$attrs.clearable !== false);
    },
    disabled() {
      return 'disabled' in this.$attrs && this.$attrs.disabled !== false;
    }
  },
  methods: {
    input(val) {
      this.$emit('input', val);
    }
  }
};
</script>
